import { render, staticRenderFns } from "./liquidations.vue?vue&type=template&id=f9424978"
import script from "./liquidations.vue?vue&type=script&lang=js"
export * from "./liquidations.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports